module.exports = __webpack_public_path__ + "img/Pack_suivi_annuel.f19a8b2a.jpg";